<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {

};
</script>
<style lang="scss">
@import url("assets/Fonts/linear-icons/style.css");

@font-face {
  font-family: "Brandon Grotesque";
  src: url("assets/Fonts/BrandonGrotesque-Medium.woff2") format("woff2"),
    url("assets/Fonts/BrandonGrotesque-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Brandon Grotesque";
  src: url("assets/Fonts/BrandonGrotesque-Bold.woff2") format("woff2"),
    url("assets/Fonts/BrandonGrotesque-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "Brandon Grotesque";
  src: url("assets/Fonts/BrandonGrotesque-Black.woff2") format("woff2"),
    url("assets/Fonts/BrandonGrotesque-Black.woff") format("woff");
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: "Brandon Grotesque";
  src: url("assets/Fonts/BrandonGrotesque-Regular.woff2") format("woff2"),
    url("assets/Fonts/BrandonGrotesque-Regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Brandon Grotesque";
  src: url("assets/Fonts/BrandonGrotesque-Light.woff2") format("woff2"),
    url("assets/Fonts/BrandonGrotesque-Light.woff") format("woff");
  font-weight: lighter;
  font-style: normal;
}
 * {
   font-family: "Brandon Grotesque";
 }
html, body {
  width: 100%; 
  height: 100%; 
  position: absolute; 
  left: 0px; 
  margin: unset !important; 
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.loader {
  border: 8px solid #f3f3f3; /* Light grey */
  border-top: 8px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
  margin: 50px auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
